import { Component, OnInit } from "@angular/core";
import { ConfigService } from "src/app/shared/services/config.service";
import { UserService } from "../../../shared/user.service";
import { HttpService } from "src/app/modules/assetModule/shared/services/http.service";

@Component({
    selector: 'app-user-activity',
    templateUrl: './user-activity.component.html',
    styleUrls: ['./user-activity.component.css']
})
export class UserActivityComponent implements OnInit {
    userStatistics: any;
    theme_color: string;
    constructor(public config: ConfigService, private userService: UserService,
        private httpService: HttpService) { }

    ngOnInit() {
        let User = JSON.parse(sessionStorage.getItem('userinfo'));
        this.theme_color = User.userSettings.userThemeType===0?'dark':'light';
        this.config.userActivity = true;
        this.config.changeTabUser(1);
        this.showActiveUsersModal();
    }

    /**
    *Method will be called to fetch the user statistics data.
    */
    showActiveUsersModal() {
        this.httpService.getBasePath().then(e => {
            this.userService.getUserStatistics().subscribe(
                data => {
                    this.userStatistics = data;

                }
            );
        });
    }
}
